import r from "./underscore.js";
function n(n) {
  var a = r(n);
  return a._chain = !0, a;
}
export { n as default };